<template>
  <div class="card" style="height: 85vh;" :class="darkMode ? 'bg-gradient-dark' : ''">
    <div class="pb-0 card-header" :class="darkMode ? 'bg-transparent' : ''">
      <h6 :class="darkMode ? 'text-white' : ''">{{ title }}</h6>
    </div>
    <div class="card-body hide-scroll" style="height: calc(100vh - 60px); overflow-y: auto;"
      :class="darkMode ? 'text-white' : ''">
      <div class="timeline timeline-one-side" :data-timeline-axis-style="darkMode ? 'dashed' : 'dotted'">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineList",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.hide-scroll {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE и Edge */
}

.hide-scroll::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}
</style>
